import { makeStyles } from "@material-ui/core";
import AppColors from './../colors/AppColors';

export const useFeatureItemStyle = makeStyles((theme) => ({
    root: {
        padding: 15,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 50)
        }
    },
    whiteRoot: {
        '&:hover': {
            backgroundColor: AppColors.lightenOrDarken(AppColors.GREY_TEXT, 65)
        }
    },

}));